import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { useFlags } from "launchdarkly-react-client-sdk";

import EmployeeStubsGrid from "./EmployeeStubsGrid";
import PageLoader from "components/common/PageLoader";
import TopHeader from "components/common/TopHeader";

import { usePermissions } from "components/Hook";

import { EmployeeDocumentsRequest } from "store/actions/EmployeePortal/EmployeeDocuments";

import { getLoadingAdditionalInfo } from "selectors/user";

import "./EmployeePayStubs.css";

function EmployeePayStub() {
  const dispatch = useDispatch();
  const { loggedInUser } = usePermissions();
  const { platformHeader } = useFlags();

  const loadingAdditionalInfo = useSelector(getLoadingAdditionalInfo);

  const loadingEmpDocs = useSelector((state) => state.EmployeeDocuments.isLoading);

  useEffect(() => {
    dispatch(EmployeeDocumentsRequest(`employees/${loggedInUser.userId}/document`));
  }, []);

  return (
    <>
      <Helmet>
        <title>Edge | Pay Slips</title>
      </Helmet>
      {(loadingAdditionalInfo || loadingEmpDocs) && <PageLoader />}
      {platformHeader && <TopHeader title="Pay slips" />}
      <div
        style={{
          display: "flex",
          background: "#FAFAFF",
          height: "calc(100vh)",
        }}
      >
        <div className="employee-paystubs-dA">
          {!platformHeader && (
            <div className="employee-paystubs-dA1">
              <div className="employee-paystubs-dA1-Menu mt-05">Your Pay Slips</div>
            </div>
          )}
          <EmployeeStubsGrid />
          <br />
        </div>
      </div>
    </>
  );
}

export default EmployeePayStub;
